var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 15.9993C29.3333 19.5356 27.9285 22.927 25.428 25.4274C22.9276 27.9279 19.5362 29.3327 16 29.3327C14.249 29.3327 12.5152 28.9878 10.8975 28.3177C9.27984 27.6477 7.80998 26.6656 6.57187 25.4274C4.07138 22.927 2.66663 19.5356 2.66663 15.9993C2.66663 12.4631 4.07138 9.07174 6.57187 6.57126C9.07235 4.07077 12.4637 2.66602 16 2.66602C17.7509 2.66602 19.4847 3.01089 21.1024 3.68096C22.7201 4.35102 24.1899 5.33314 25.428 6.57126C26.6662 7.80937 27.6483 9.27923 28.3184 10.8969C28.9884 12.5146 29.3333 14.2484 29.3333 15.9993ZM7.99996 17.3327H18.6666L14 21.9993L15.8933 23.8927L23.7866 15.9993L15.8933 8.10602L14 9.99935L18.6666 14.666H7.99996V17.3327Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircle);
export default __webpack_public_path__ + "static/media/arrowRightCircle.2ce8f305649a0cd5d4eb9fb36c74dcbd.svg";
export { ForwardRef as ReactComponent };